export const generalMessages = {}

export const successMessages = {
  // Defaults
  defaultForm: 'Success - Form Saved',

  // Member
  login: 'You are now logged in',
  signUp: 'You are now signed up. Please login to continue.',
  forgotPassword: 'Password reset. Please check your email.',
}

export const errorMessages = {
  // Defaults
  default: 'Hmm, an unknown error occurred',
  timeout: 'Server Timed Out. Check your internet connection',
  invalidJson: 'Response returned is not valid JSON',
  missingData: 'Missing data',

  // Member
  memberNotAuthd: 'You need to be logged in, to update your profile',
  memberExists: 'Member already exists',
  missingFirstName: 'First name is missing',
  missingLastName: 'Last name is missing',
  missingEmail: 'Email is missing',
  missingPassword: 'Password is missing',
  passwordsDontMatch: 'Passwords do not match',

  // Company
  companyNotFound: 'This company could not be found',

  address: 'Office location is missing',
  numberOfUnits: 'Number of Units is missing',
  numberOfUnitsMinimum: 'The minimum number of units is one',
  bedrooms: 'Unit Types is missing',
  currency: 'Currency is missing',
  frontMessageId: 'Front message ID is missing',
  company: 'Corporate is missing',
  reference: 'Reference is missing',
  fillCheckInOut: 'You must fill out Check In and Check Out Dates',
  fillCheckInOutOrDaysNights:
    'You must fill out either Check In / Out Dates or Length of Stay',
  fillCheckInOutHasShortlist:
    'You must fill out Check In / Out Dates when the housing request has a shortlist',
  invalidEmail: 'Email is not valid',
  phoneTooShort: 'Phone should have 10 digits or more',
  consultant: 'Consultant is required',
  rmc: 'Client is required',
  alternativeUnitTypeSameAsUnitType: 'Must be different from Unit Type(s)',

  // PWC
  missingAdditionalEmail: 'Additional email is missing',

  airportTransfer: 'Paid by is missing',
}

export const alertMessages = {
  inviteSent: 'Invite was successfully sent',
  userBlocked: 'User blocked',
  userUnblocked: 'User unblocked',
  resetPassword: 'Reset password link was successfully sent',
}
